/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { __PackagingAll } from "request/configuration/__Packaging";
import ConfigurationHeader from "../ConfigurationHeader";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import Pagination from "components/Pagination/Pagination";
import TbodyPackaging from "components/Tables/TbodyPackaging";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import environment from "constants/apiConst";
import TableOrder from "components/Tables/TableOrder";
import PackagingForm from "../forms/PackagingForm";
import FormPackaginShow from "../FormShow/FormPackaginShow";

import { SectionContainerGene } from "styled/SectionContainer.styled";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const Packaging = () => {
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState([]);
  const freeZone_id = useSelector((state) => state.auth.dataUser.token);

  const {
    setRequestEdit,
    setRequestCreate,
    setRequestDelete,
    setFormEdit,
    setFormShow,
    update
  } = useContext(ConfigurationCRUDContext);

  const location = useLocation();

  const { q = "" } = queryString.parse(location.search);

  const thead = [
    { name: "Código", order: "code_packaging" },
    { name: "Nombre", order: "name_packaging" },
    { name: "Estado", order: "status_packaging" },
    { name: "Acciones", order: "actions_packaging" }
  ];

  const formEdit = () => {
    return <PackagingForm />;
  };
  const formShow = () => {
    return <FormPackaginShow />;
  };

  useEffect(() => {
    setFormEdit(formEdit);
    setFormShow(formShow);
    setRequestEdit(environment.PACKAGING_UPDATE);
    setRequestCreate(environment.PACKAGIN_CREATE);
    setRequestDelete(environment.PACKAGING_DELETE);
  }, [page, q, update]);

  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configPackaging", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.PACKAGING,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <SectionContainerGene>
      <ConfigurationHeader title="Embalajes"></ConfigurationHeader>
      {isLoading || (
        <TableOrder
          thead={thead}
          data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
          setData={setCurrentPage}
          loading={isLoading}
          tbodyData={TbodyPackaging}
        />
      )}
      <Pagination
        thead={thead}
        page={page}
        setPage={setPage}
        maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
        loading={isLoading}
      />
    </SectionContainerGene>
  );
};

export default Packaging;
